import { chatAttachmentAssetFactory as factory } from '@lovejunk/core'

import Mock from './Mock'
import Tile from './Tile'

export default factory({
  Mock,
  Tile,
})
